// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"2d263012","265":"ace6abbe","302":"721eea18","400":"f12b4bdc"}[chunkId] + ".chunk.js";
};